import React, { useContext } from 'react'
import { ProcessContext } from '../../wrappers/ProcessContext'
import ProcessCard from './ProcessCard'

const LandingPage = () => {
    const { processes } = useContext(ProcessContext)

    if (!processes && !processes.length) {
        return null
    }

    return (
        <>
            <div className="section">
                <div className="header">
                    <h2 className="title">Workflow Management</h2>
                </div>
                <div className="section">
                    <div className="processLinks">
                        {processes.map((process, idx) => {
                            return (
                                <ProcessCard
                                    key={`process-${idx}`}
                                    process={process}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default LandingPage
